import useCommonStore from "../../store/store";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }: any) => {
  const { isLoggedIn,authData } = useCommonStore();
  return isLoggedIn ? element : <Navigate to={`/?redirect_uri=${window.location.origin}/rate`} />;
};

export default ProtectedRoute;
